import { createContext, useContext } from 'react'

import api from 'services/api'

export interface SignInRequest {
  email: string
  password: string
}

interface AuthContextData {
  signIn(data: SignInRequest): Promise<void>
  signOut: () => void
  signUp(data: ISignUpRequest): Promise<void>
}

interface ISignUpRequest {
  firstname: string
  lastname: string
  country?: string
  birthdate: string
  email: string
  password: string
  confirmPassword?: string
  interests?: string[]
  profilePicture?: string
  coverPicture?: string
  facebook?: string
  instagram?: string
  gender?: string
  about?: string
  confirmPolicy: boolean
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData)

export const AuthProvider = ({ children }: any) => {
  const signIn = async ({ email, password }: SignInRequest) => {
    const response = await api.post('auth/login', {
      username: email,
      password
    })

    const { access_token } = response.data

    if (!access_token) {
      throw new Error('A API não retornou um token de autenticação.')
    }

    api.defaults.headers.common.Authorization = `Bearer ${access_token}`
    window.localStorage.setItem('token', access_token)

    try {
      const { data: authenticatedUser } = await api.get('/users')

      if (!authenticatedUser?.id) {
        throw new Error('A API não retornou o usuário autenticado.')
      }

      window.localStorage.setItem('user', JSON.stringify(authenticatedUser))
    } catch (error) {
      delete api.defaults.headers.common.Authorization
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('user')
      throw error
    }
  }

  const signUp = async (register: ISignUpRequest) => {
    const payload: any = { ...register }
    delete payload.confirmPassword

    await api.post('users', {
      ...payload,
      confirmPolicy: Boolean(register.confirmPolicy)
    })

    await signIn({
      email: register.email,
      password: register.password
    })
  }

  const signOut = () => {
    delete api.defaults.headers.common.Authorization
    localStorage.clear()
    window.location.href = '/'
  }

  return (
    <AuthContext.Provider
      value={{
        signIn,
        signOut,
        signUp
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth(): AuthContextData {
  const context = useContext(AuthContext)

  return context
}
